import React from 'react';
import classNames from 'classnames';

type NoImageAvailableProps = {
    width?: string;
    height?: string;
    className?: string;
    text?: string;
};

export const NoImageAvailable = ({
    width = '100px',
    height = '56.25px',
    className,
    text = 'No image available',
}: NoImageAvailableProps) => {
    const containerClassName = classNames(
        'bg-grey-20 rounded-lg border border-white text-grey-80 text-xs flex items-center justify-center text-center',
        className
    );

    return (
        <div className={containerClassName} style={{ width, height }}>
            {text}
        </div>
    );
};

export default NoImageAvailable;
